import { render, staticRenderFns } from "./BaseFlatCard.vue?vue&type=template&id=f2b104ac&scoped=true&"
var script = {}
import style0 from "./BaseFlatCard.vue?vue&type=style&index=0&id=f2b104ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2b104ac",
  null
  
)

export default component.exports